import {
  Accordion,
  Box,
  Button,
  ChevronIcon,
  Flex,
  Group,
  Select,
  SimpleGrid,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { noteType_Client_Options } from "../../utils";
import { FiPlus } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";

const CustomForm = forwardRef(
  ({ classes, view, errorField, setErrorField, onSubmit }, ref) => {
    useEffect(() => {
      if (errorField === "" || errorField === undefined)
        form.setValues(initialValues);
    }, [errorField]);
    const isMobileScreen = useMediaQuery("(max-width: 600px)");
    const { fieldType } = useSelector((state) => state.note);
    console.log("🚀 ~ fieldType:", fieldType);
    const [others, setOthers] = useState(false);

    const [singleChoice, setSingleChoice] = useState(false);
    const [singleOption, setSingleOption] = useState([]);
    const [singleOptionInput, setSingleOptionInput] = useState("");

    const [multipleChoice, setMultipleChoice] = useState(false);
    const [multipleOptions, setMultipleOptions] = useState([]);
    const [optionInput, setOptionInput] = useState("");

    const [dropdownChoice, setDropdownChoice] = useState(false);
    const [dropdownOption, setDropdownOption] = useState([]);
    const [dropdownOptionInput, setDropdownOptionInput] = useState("");

    // constants
    const initialValues = {
      field: "",
      fieldType: "",
      priority: "",
      viewOnly: "",
      others: "",
      multipleChoice: "",
      singleChoice: "",
      dropdownChoice: "",
    };
    const validations = {
      field: (value) => (value ? null : "Please specify Field Name"),
      fieldType: (value) => (value ? null : "Select Field Type"),
      priority: (value) => (value ? null : "Select Priority"),
      viewOnly: (value) => (value ? null : "Select View Only"),
      // field: (value) => (value ? null : null),
      // fieldType: (value) => (value ? null : null),
      // priority: (value) => (value ? null : null),
      // viewOnly: (value) => (value ? null : null),
    };

    const form = useForm({
      initialValues,
      validate: validations,
    });

    useImperativeHandle(ref, () => ({
      forceSubmit: () => plusRef?.current?.click(),
    }));

    // refs
    const plusRef = useRef();
    const inputRef = useRef();

    // functions type change
    const onFieldTypeChange = (fieldT) => {
      form.setFieldValue("fieldType", fieldT);
      let selectedFieldType = fieldType?.find(
        (value) => value?.id === fieldT
      )?.name;
      setOthers(selectedFieldType?.toUpperCase() === "OTHER");
      setMultipleChoice(selectedFieldType?.toUpperCase() === "MULTIPLE CHOICE");
      setSingleChoice(selectedFieldType?.toUpperCase() === "SINGLE CHOICE");
      setDropdownChoice(selectedFieldType?.toUpperCase() === "DROPDOWN");
    };

    // multiple choice add
    const handleAddOption = () => {
      if (optionInput) {
        setMultipleOptions((prev) => [...prev, optionInput]);
        setOptionInput("");
      }
    };

    // single choice add
    const handleAddSingleOption = () => {
      if (singleOptionInput) {
        setSingleOption((prev) => [...prev, singleOptionInput]);
        setSingleOptionInput("");
      }
    };

    // dropdown choice add
    const handleAddDropdownOption = () => {
      if (dropdownOptionInput) {
        setDropdownOption((prev) => [...prev, dropdownOptionInput]);
        setDropdownOptionInput("");
      }
    };

    // multiple choice remove
    const handleRemoveOption = (index) => {
      setMultipleOptions((prev) => prev.filter((_, i) => i !== index));
    };

    // single choice remove
    const handleRemoveSingleOption = (index) => {
      setSingleOption((prev) => prev.filter((_, i) => i !== index));
    };

    // dropdown choice remove
    const handleRemoveDropdownOption = (index) => {
      setDropdownOption((prev) => prev.filter((_, i) => i !== index));
    };

    // submit
    const submit = (values) => {
      let selectedFieldType = fieldType?.find(
        (value) => value?.id === values?.fieldType
      )?.name;
      let obj = {
        ...values,
        priority: values?.priority == "Yes",
        viewOnly: values?.viewOnly == "Yes",
        multipleChoice: multipleOptions || [],
        singleChoice: singleOption || [],
        dropdownChoice: dropdownOption || [],
      };
      if (selectedFieldType?.toUpperCase() === "OTHER") {
        obj.options = "Other";
      } else if (selectedFieldType?.toUpperCase() === "MULTIPLE CHOICE") {
        obj.options = "multipleOptions";
      } else if (selectedFieldType?.toUpperCase() === "SINGLE CHOICE") {
        obj.options = "singleOptions";
      } else if (selectedFieldType?.toUpperCase() === "DROPDOWN") {
        obj.options = "dropdownOptions";
      }
      onSubmit(obj);
      setMultipleOptions([]);
      setMultipleChoice(false);
      setSingleChoice(false);
      setDropdownChoice(false);
      setSingleOption([]);
      setDropdownOption([]);
      form.reset();
      setOptionInput("");
      setOthers(false);
    };

    return (
      <form onSubmit={form?.onSubmit((values) => submit(values))}>
        <Box>
          {!view && (
            <>
              <Accordion
                key={"field-form"}
                defaultValue={"field-form"}
                variant="separated"
                radius="md"
              >
                <Accordion.Item value={"field-form"} className={classes.item}>
                  <Accordion.Control>
                    <Group position="apart">
                      <Text style={{ fontWeight: 600 }}>
                        {view ? "Field" : "Custom Field "}
                      </Text>
                    </Group>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Box>
                      <SimpleGrid cols={isMobileScreen ? 1 : 2}>
                        <TextInput
                          size="md"
                          ref={inputRef}
                          placeholder="Field Name"
                          className={classes.myfont}
                          {...form.getInputProps("field")}
                          disabled={view}
                          radius={"md"}
                        />
                        <Select
                          size="md"
                          data={fieldType
                            ?.filter(
                              (v) =>
                                v?.name != noteType_Client_Options &&
                                v?.name !== "Facilities" &&
                                v?.name !== "Staff" &&
                                v?.name !== "Facility Types" &&
                                v?.name !== "Support Plan" &&
                                v?.name !== "Provider" &&
                                v?.name !== "Medication Records"
                            )
                            ?.map((val) => ({
                              value: val?.id,
                              label: val?.name?.toUpperCase(),
                            }))}
                          placeholder="Field Type"
                          className={classes.myfont}
                          {...form.getInputProps("fieldType")}
                          disabled={view}
                          radius={"md"}
                          onChange={onFieldTypeChange}
                          rightSection={
                            <ChevronIcon
                              className={classes.chevron}
                              size="1.5rem"
                              stroke={1.5}
                              style={{
                                opacity: 0.5,
                              }}
                            />
                          }
                        />
                        {others ? (
                          <TextInput
                            size="md"
                            // label="List Options"
                            placeholder="Eg. Option1,Option2,Option3"
                            className={classes.myfont}
                            radius={"md"}
                            {...form.getInputProps("others")}
                            disabled={view}
                            rightSection={
                              <ChevronIcon
                                className={classes.chevron}
                                size="1.5rem"
                                stroke={1.5}
                                style={{
                                  opacity: 0.5,
                                }}
                              />
                            }
                          />
                        ) : null}
                        <Select
                          size="md"
                          placeholder="Field Priority"
                          data={["Yes", "No"]}
                          radius={"md"}
                          className={classes.myfont}
                          {...form.getInputProps("priority")}
                          disabled={view}
                          rightSection={
                            <ChevronIcon
                              className={classes.chevron}
                              size="1.5rem"
                              stroke={1.5}
                              style={{
                                opacity: 0.5,
                              }}
                            />
                          }
                        />
                        <Select
                          size="md"
                          placeholder="View Only"
                          data={["Yes", "No"]}
                          radius={"md"}
                          className={classes.myfont}
                          {...form.getInputProps("viewOnly")}
                          disabled={view}
                          rightSection={
                            <ChevronIcon
                              className={classes.chevron}
                              size="1.5rem"
                              stroke={1.5}
                              style={{
                                opacity: 0.5,
                              }}
                            />
                          }
                        />
                      </SimpleGrid>
                      {multipleChoice && (
                        <Box mt={".5rem"}>
                          <Text size="sm" color="var(--app-text)" ff={"Inter"}>
                            Add Options
                          </Text>
                          <Box mt={"0.5rem"}>
                            {multipleOptions?.map((option, index) => (
                              <Flex key={index} align="center">
                                <Text size="sm" color="var(--app-text)" ff={"Inter"}>
                                  {option}
                                </Text>
                                <Button
                                  variant="unstyled"
                                  c="red"
                                  size="xs"
                                  onClick={() => handleRemoveOption(index)}
                                >
                                  <RxCross2 color="red" />
                                </Button>
                              </Flex>
                            ))}
                          </Box>
                          <Flex align={"center"} gap={".5rem"} w={"100%"}>
                            <TextInput
                              size="md"
                              w={"50%"}
                              value={optionInput}
                              onChange={(e) => setOptionInput(e.target.value)}
                              placeholder={`Option ${
                                multipleOptions?.length + 1
                              }`}
                              // {...form.getInputProps("multipleOptions")}
                              className={classes.myfont}
                              disabled={view}
                            />
                            <Button
                              size="md"
                              radius="md"
                              variant="unstyled"
                              c={"var(--app-text)"}
                              onClick={handleAddOption}
                            >
                              <FiPlus />
                            </Button>
                          </Flex>
                        </Box>
                      )}
                      {singleChoice && (
                        <Box mt={"0.5rem"}>
                          <Text size="sm" color="var(--app-text)" ff={"Inter"}>
                            Add Options
                          </Text>

                          <Box mt={"0.5rem"}>
                            {singleOption?.map((option, index) => (
                              <Flex key={index} align="center">
                                <Text size="sm" color="var(--app-text)" ff={"Inter"}>
                                  {option}
                                </Text>
                                <Button
                                  variant="unstyled"
                                  c="red"
                                  size="xs"
                                  onClick={() =>
                                    handleRemoveSingleOption(index)
                                  }
                                >
                                  <RxCross2 color="red" />
                                </Button>
                              </Flex>
                            ))}
                          </Box>
                          <Flex align={"center"} gap={".5rem"} w={"100%"}>
                            <TextInput
                              size="md"
                              w={"50%"}
                              value={singleOptionInput}
                              onChange={(e) =>
                                setSingleOptionInput(e.target.value)
                              }
                              placeholder={`Option ${
                                singleOptionInput?.length + 1
                              }`}
                              className={classes.myfont}
                              disabled={view}
                            />
                            <Button
                              size="md"
                              radius="md"
                              c={"var(--app-text)"}
                              variant="unstyled"
                              onClick={handleAddSingleOption}
                            >
                              <FiPlus />
                            </Button>
                          </Flex>
                        </Box>
                      )}

                      {dropdownChoice && (
                        <Box mt={"0.5rem"}>
                          <Text size="sm" color="var(--app-text)" ff={"Inter"}>
                            Add Options
                          </Text>

                          <Box mt={"0.5rem"}>
                            {dropdownOption?.map((option, index) => (
                              <Flex key={index} align="center">
                                <Text size="sm" color="var(--app-text)" ff={"Inter"}>
                                  {option}
                                </Text>
                                <Button
                                  variant="unstyled"
                                  c="red"
                                  size="xs"
                                  onClick={() =>
                                    handleRemoveDropdownOption(index)
                                  }
                                >
                                  <RxCross2 color="red" />
                                </Button>
                              </Flex>
                            ))}
                          </Box>
                          <Flex align={"center"} gap={".5rem"} w={"100%"}>
                            <TextInput
                              size="md"
                              w={"50%"}
                              value={dropdownOptionInput}
                              onChange={(e) =>
                                setDropdownOptionInput(e.target.value)
                              }
                              placeholder={`Option ${
                                dropdownOptionInput?.length + 1
                              }`}
                              className={classes.myfont}
                              disabled={view}
                            />
                            <Button
                              size="md"
                              radius="md"
                              c={"var(--app-text)"}
                              variant="unstyled"
                              onClick={handleAddDropdownOption}
                            >
                              <FiPlus />
                            </Button>
                          </Flex>
                        </Box>
                      )}
                    </Box>
                    <Box>
                      <Flex
                        justify="flex-end"
                        align="center"
                        direction="row"
                        gap={"1rem"}
                        mt={"1rem"}
                      >
                        {!view && (
                          <Button
                            size="md"
                            radius="md"
                            color="gray"
                            type="submit"
                            ref={plusRef}
                          >
                            Add
                          </Button>
                        )}
                      </Flex>

                      {/* <ActionIcon
                  color="blue"
                  variant="light"
                  mt={5}
                  size={44}
                  onClick={() => {
                    setErrorField("");
                    form.setValues(initialValues);
                  }}
                >
                  <Icon360 />
                </ActionIcon> */}
                    </Box>
                  </Accordion.Panel>
                </Accordion.Item>
              </Accordion>
            </>
          )}

          {errorField != "" ? (
            <p style={{ color: "red", margin: 0, padding: 0 }}>{errorField}</p>
          ) : (
            ""
          )}
        </Box>
      </form>
    );
  }
);

export default CustomForm;
